import { clsx } from 'clsx';
import type { Dispatch, SetStateAction } from 'react';

import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';

import styles from './addressSuggestions.module.css';

interface AddressSuggestionsProps {
  setDisplayAddress: Dispatch<SetStateAction<string>>;
}

export function AddressSuggestions({
  setDisplayAddress,
}: AddressSuggestionsProps) {
  const { addressSuggestions, selectSuggestedAddress } = useStoreSwitcher();

  const onSuggestedAddressSelected = (address: string) => {
    setDisplayAddress(address);
    selectSuggestedAddress(address);
  };

  return (
    <div className={styles['suggestions']}>
      {addressSuggestions.map((address) => {
        return (
          /** @todo use elements with appropriate role */
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div
            key={address.value}
            className={clsx(styles['address'], 'focus-visible')}
            onClick={() => onSuggestedAddressSelected(address.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                onSuggestedAddressSelected(address.value);
              }
            }}
          >
            {address.label}
          </div>
        );
      })}
    </div>
  );
}
